import { render, staticRenderFns } from "./BannedList.vue?vue&type=template&id=1d7840c5&"
import script from "./BannedList.vue?vue&type=script&lang=js&"
export * from "./BannedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports